/* template */
<template minapp="mpx" xlang="wxml"><es-popup :closeable="(false)" :show="(option.show)" :style="[(style)] | transRpxStyle"><div class="es-dialog" :class='[$attrs["custom-class"]]'><div class="es-dialog__header custom-header"><template v-if="(option.title)">{{option.title}}</template><slot name="title" v-else></slot></div><div :class="(classnames)" class="es-dialog__body custom-body"><template v-if="(option.message)">{{option.message}}</template><slot name="content" v-else></slot></div><div class="es-dialog__footer custom-footer"><es-button block @click="handleAction('cancel')" class="es-dialog__button custom-cancel" :custom-class='["es-dialog__cancel"].join(" ")' v-if="(option.showCancelButton)">{{option.cancelButtonText}}</es-button><es-button :class="(showClass? 'es-dialog__buttonS':'')" block @click="handleAction('confirm')" class="es-dialog__button es-dialog__border-left custom-confirm" :custom-class='["es-dialog__confirm"].join(" ")' v-if="(option.showConfirmButton)">{{option.confirmButtonText}}</es-button></div></div></es-popup></template>

/* styles */
<style lang="stylus" src="./style.styl" mpxStyleOptions='{"mid":"m3651661c"}'>
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m3651661c"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex3651661c%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex3651661c%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m3651661c"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index3651661c/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-popup':getComponent(require("../popup/index.mpx?isComponent&outputPath=components%2Findex9216a4d4%2Findex")),'es-button':getComponent(require("../button/index.mpx?isComponent&outputPath=components%2Findexbc68cb48%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
